import { useQuery } from '@tanstack/react-query';

import { contactsApi } from '@/api/contacts';

export function useContacts(leaseId: number | null) {
  return useQuery({
    queryKey: ['contacts', leaseId],
    queryFn: () => contactsApi.list({ lease_id: leaseId as number }),
    enabled: leaseId !== null,
  });
}
